import { riskZonesQueryKeys } from "./queryKeys"
import { useRiskZonesQuery } from "./useRiskZonesQueries"

export function useRiskZoneGrades(params = {}, config = {}) {
    const url = "risk_zone_clusters/stats/average_grade/"
    const queryKey = riskZonesQueryKeys["grades"](params)

    return useRiskZonesQuery(
        url,
        queryKey,
        params,
        config,
    )
}